/**
 * Pricing.js - used for calculating the end price for a booking,
 * taking into consideration rate types, their min stays and base pax
 */

var paxDailyPricing = function(nights){
    var nightRates = [];
    var nightsStaying = nights.length,
        bestMinStay = 1;

    // Find the best min stay available for the number of nights stay
    $.each(nights, function(i, details){
        var possibleMinStay = resolveBestMinStayInDetails(details, nightsStaying);
        if(bestMinStay < possibleMinStay) {
            bestMinStay = possibleMinStay;
        }
    });

    // loop through the nights staying
    for(var night = 0, nightsLen = nights.length; night < nightsLen; night++){
        // loop through the min stays
        for(var minStay in nights[night].minStays){
            if(nights[night].minStays.hasOwnProperty(minStay)) {
                if (nightRates[minStay] === undefined) {
                    nightRates[minStay] = {adults: 0, children: 0, infants: 0};
                    // check pax
                    if (!$.isEmptyObject(nights[night].minStays[minStay].adultsPrices))
                        nightRates[minStay].adults = 1;
                    if (!$.isEmptyObject(nights[night].minStays[minStay].childrenPrices))
                        nightRates[minStay].children = 1;
                    if (!$.isEmptyObject(nights[night].minStays[minStay].infantsPrices))
                        nightRates[minStay].infants = 1;
                } else {
                    if (!$.isEmptyObject(nights[night].minStays[minStay].adultsPrices))
                        nightRates[minStay].adults++;
                    if (!$.isEmptyObject(nights[night].minStays[minStay].childrenPrices))
                        nightRates[minStay].children++;
                    if (!$.isEmptyObject(nights[night].minStays[minStay].infantsPrices))
                        nightRates[minStay].infants++;
                }
            }
        }
    }
    // loop through the nightRates and ensure that the rates are in there.
    var adultRates = null, childrenRates = null, infantRates = null;
    var basePrices = [];
    for(var rate = nightsStaying; rate > 0; rate--){
        if(nightRates.hasOwnProperty(rate)){
            // check that the rates are correct
            if(nightRates[rate].adults === nightsStaying && !adultRates){
                // add the adult rate
                adultRates = rate;
                // loop through nights and set the rates per night for adults
                var paxArrayRates = [];
                for(var n = 0, nightsLength = nights.length; n < nightsLength; n++){
                    if(n < bestMinStay && nights[n].minStays[rate].hasOwnProperty('basePackagePrice')) {
                        paxArrayRates[n] = nights[n].minStays[rate].packagePrices;
                        basePrices[n] = nights[n].minStays[rate].basePackagePrice;
                    } else {
                        paxArrayRates[n] = nights[n].minStays[rate].adultsPrices;
                        basePrices[n] = nights[n].minStays[rate].basePrice;
                    }
                }
                adultRates = paxArrayRates;
            }
            if(nightRates[rate].children === nightsStaying && !childrenRates){
                // add the children rate
                childrenRates = rate;
                // loop through nights and set the rates per night for children
                var paxArrayRates = [];
                for(var n = 0, nightsLength = nights.length; n < nightsLength; n++){
                    if(n < bestMinStay && nights[n].minStays[rate].hasOwnProperty('packagePrices')) {
                        paxArrayRates[n] = nights[n].minStays[rate].packagePrices;
                    } else {
                        paxArrayRates[n] = nights[n].minStays[rate].childrenPrices;
                    }
                }
                childrenRates = paxArrayRates;
            }
            if(nightRates[rate].infants === nightsStaying && !infantRates){
                // add the infant rate
                infantRates = rate;
                // loop through nights and set the rates per night for infants
                var paxArrayRates = [];
                for(var n = 0, nightsLength = nights.length; n < nightsLength; n++){
                    paxArrayRates[n] = nights[n].minStays[rate].infantsPrices;
                }
                infantRates = paxArrayRates;
            }
        }
    }

    var nightlyPrices = {};
    nightlyPrices.adults = adultRates;
    nightlyPrices.children = childrenRates;
    nightlyPrices.infants = infantRates;
    nightlyPrices.basePrices = basePrices;

    return nightlyPrices;
};

var getPrice = function(pricingArr, adults, children, infants){
    // Defined variable that will commonly be used within this function
    var bestMinStay, paxDailyPrices, priceOnNight, paxPricing, nights, basePax, total, isPackageRate, priceAs,
        hasChildRate, hasInfantRate, paxConfig;

    // Extract the pricing from pricing array
    paxDailyPrices = paxDailyPricing(pricingArr);
    // Reset the base pax, total
    basePax = total = 0;
    // Get then number of nights stay
    nights = pricingArr.length;
    // Default min stay to 1
    bestMinStay = null;
    // Find the best min stay available for the number of nights stay
    $.each(pricingArr, function(i, details){
        var possibleMinStay = resolveBestMinStayInDetails(details, nights);
        if(bestMinStay < possibleMinStay) {
            bestMinStay = possibleMinStay;
        }
    });

    // If the number of night stay is lease then the possible min stay then we return a null value as then number of
    // of night stay cannot be calculate.
    if(typeof bestMinStay === 'undefined' || bestMinStay === null) {
        return null;
    }

    paxConfig = {
        'adults':   adults,
        'children': children,
        'infants':  infants
    };

    // loop through the nights
    for(var night = 0; night < nights; night++) {
        hasChildRate = hasInfantRate = false;
        isPackageRate = pricingArr[night].minStays.hasOwnProperty(bestMinStay) ?
            pricingArr[night].minStays[bestMinStay].hasOwnProperty('basePackagePrice') : false;

        basePax = pricingArr[night].basePax;
        // Checking if there child or infant rate mapped to the the current rate
        if(pricingArr[night].minStays.hasOwnProperty(bestMinStay)) {
            hasChildRate = pricingArr[night].minStays[bestMinStay].hasChildRate;
            hasInfantRate = pricingArr[night].minStays[bestMinStay].hasInfantRate;
        }
        priceAs = resolvePaxConfig(basePax, paxConfig, hasChildRate, hasInfantRate);
        $.each(priceAs, function(paxType, paxCount){
            priceOnNight    = 0;
            paxPricing      = paxDailyPrices[paxType] !== null ? paxDailyPrices[paxType][night] : false;

            if(paxPricing && paxPricing[paxCount]){
                priceOnNight = parseFloat(paxPricing[paxCount]);
            }
            // If it a package rate then use the fixed if number of night is within the min stay
            if(night < bestMinStay && isPackageRate && priceOnNight > 0) {
                priceOnNight = priceOnNight / bestMinStay;
            }

            total += priceOnNight;
        });
    }

    return total;
};

var resolvePaxConfig = function(basePax, paxConfig, hasChildRate, hasInfantRate) {
    var paxCount, newPaxConfig, additionalPaxNeeded;

    newPaxConfig = {
        'adults':   0,
        'children': 0,
        'infants':  0
    };


    // Loop through the pax types
    $.each(['adults','children','infants'], $.proxy(function(paxConfig, i, paxType) {
        // Get the pax count
        paxCount = paxConfig[paxType];

        // If there is no count, then just continue to the next pax type
        if(paxCount === 0) {
            if(paxType === 'adults') {
                additionalPaxNeeded = basePax;
            }
            return true;
        }

        // If there no valid infant rate, then just continue to the next pax type
        if(paxType === 'infants' && !hasInfantRate) {
            return true;
        }

        // Check if we have any "additional pax needed" to fill a base pax of a previous type
        if(additionalPaxNeeded > 0) {
            // Default to base pax as this always must be fulfilled. Fixes no adult pricing issues
            if(newPaxConfig.adults === 0) {
                newPaxConfig.adults = basePax;
            }

            // Try to satisfy this condition with the amount of pax we have here
            additionalPaxNeeded -= paxCount;
            // If we still need additional pax, or we have completely satisfied the additional pax, we
            // can continue to the next pax type
            if(additionalPaxNeeded >= 0) {
                return true;
            }
            // Otherwise, additional pax needed is now a negative value that refers to the amount of extra
            // pax we have
            paxCount = Math.abs(additionalPaxNeeded);
        }

        // Only if this is adult pax count, we have to check that the base pax is satisfied.
        if(paxType === 'adults') {
            // Check that this pax count is enough, otherwise we need addtional pax
            if(paxCount < basePax) {
                // The base pax will be the number of adults considered for the price
                newPaxConfig.adults = basePax;
                additionalPaxNeeded = basePax - paxCount;
            }
            else {
                // Save the number of adults
                newPaxConfig.adults = paxCount;
            }
        }
        else {
            // If there no valid child rate, then add the child pax as additional pax to adults
            if(paxType === 'children' && !hasChildRate) {
                paxType = 'adults';
            }

            newPaxConfig[paxType] += paxCount;
        }
    }, this, paxConfig));
    return newPaxConfig;
};

/**
 * Find and return the best possible min stay from the given details and the number on nights stay
 * @param details
 * @param numNights
 * @returns {*}
 */
var resolveBestMinStayInDetails = function(details, numNights) {
    var bestMinStay = null;

    // Loop through the valid min stays until we find a price
    $.each(details.minStays, function (minStay, minStayDetails) {
        if (minStay <= numNights &&
            (bestMinStay === null || minStay > bestMinStay) &&
            minStayDetails !== null &&
            minStayDetails['basePrice'] !== null
        ) {
            bestMinStay = minStay;
        }
    });
    return parseInt(bestMinStay, 10);
};

var getTestingArray = function(){
    var validPricings = [[{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":null,"adultsPrices":[],"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":[]},"2":{"hasChildRate":true,"basePrice":null,"adultsPrices":[],"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":[]},"3":{"hasChildRate":true,"basePrice":175,"adultsPrices":{"1":175,"2":175,"3":194,"4":213,"5":232,"6":251},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":null,"adultsPrices":[],"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":[]},"2":{"hasChildRate":true,"basePrice":155,"adultsPrices":{"1":155,"2":155,"3":178,"4":201,"5":224,"6":247},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}},"3":{"hasChildRate":true,"basePrice":175,"adultsPrices":{"1":175,"2":175,"3":194,"4":213,"5":232,"6":251},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":null,"adultsPrices":[],"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":[]},"2":{"hasChildRate":true,"basePrice":155,"adultsPrices":{"1":155,"2":155,"3":178,"4":201,"5":224,"6":247},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}},"3":{"hasChildRate":true,"basePrice":175,"adultsPrices":{"1":175,"2":175,"3":194,"4":213,"5":232,"6":251},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":165,"adultsPrices":{"1":165,"2":165,"3":185,"4":205,"5":225,"6":245},"childrenPrices":null,"infantsPrices":null},"2":{"hasChildRate":false,"basePrice":159,"adultsPrices":{"1":159,"2":159,"3":179,"4":199,"5":219,"6":239},"childrenPrices":null,"infantsPrices":null}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":165,"adultsPrices":{"1":165,"2":165,"3":185,"4":205,"5":225,"6":245},"childrenPrices":null,"infantsPrices":null},"2":{"hasChildRate":false,"basePrice":159,"adultsPrices":{"1":159,"2":159,"3":179,"4":199,"5":219,"6":239},"childrenPrices":null,"infantsPrices":null}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":165,"adultsPrices":{"1":165,"2":165,"3":185,"4":205,"5":225,"6":245},"childrenPrices":null,"infantsPrices":null},"2":{"hasChildRate":false,"basePrice":159,"adultsPrices":{"1":159,"2":159,"3":179,"4":199,"5":219,"6":239},"childrenPrices":null,"infantsPrices":null}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":150,"adultsPrices":{"1":150,"2":150,"3":170,"4":190,"5":210,"6":230},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":null}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":150,"adultsPrices":{"1":150,"2":150,"3":170,"4":190,"5":210,"6":230},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":null}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":150,"adultsPrices":{"1":150,"2":150,"3":170,"4":190,"5":210,"6":230},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":null}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":120,"adultsPrices":{"1":120,"2":120,"3":140,"4":160,"5":180,"6":200},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":120,"adultsPrices":{"1":120,"2":120,"3":140,"4":160,"5":180,"6":200},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":120,"adultsPrices":{"1":120,"2":120,"3":140,"4":160,"5":180,"6":200},"childrenPrices":{"1":15,"2":30,"3":45,"4":60,"5":75,"6":90},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0}}}}],[{"basePax":1,"minStays":{"1":{"hasChildRate":true,"basePrice":50,"adultsPrices":{"1":50},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":5}}}},{"basePax":1,"minStays":{"1":{"hasChildRate":true,"basePrice":50,"adultsPrices":{"1":50},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":5}}}},{"basePax":1,"minStays":{"1":{"hasChildRate":true,"basePrice":50,"adultsPrices":{"1":50},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":5}}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":115,"adultsPrices":{"1":115,"2":115},"childrenPrices":{"1":115,"2":115},"infantsPrices":null}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":115,"adultsPrices":{"1":115,"2":115},"childrenPrices":{"1":115,"2":115},"infantsPrices":null}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":115,"adultsPrices":{"1":115,"2":115},"childrenPrices":{"1":115,"2":115},"infantsPrices":null}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":40,"adultsPrices":{"1":40,"2":40,"3":60,"4":80,"5":100,"6":120,"7":140,"8":160},"childrenPrices":{"1":40,"2":40,"3":60,"4":80,"5":100,"6":120,"7":140,"8":160},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":40,"adultsPrices":{"1":40,"2":40,"3":60,"4":80,"5":100,"6":120,"7":140,"8":160},"childrenPrices":{"1":40,"2":40,"3":60,"4":80,"5":100,"6":120,"7":140,"8":160},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":40,"adultsPrices":{"1":40,"2":40,"3":60,"4":80,"5":100,"6":120,"7":140,"8":160},"childrenPrices":{"1":40,"2":40,"3":60,"4":80,"5":100,"6":120,"7":140,"8":160},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0}}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":50,"adultsPrices":{"1":50,"2":50,"3":70,"4":90,"5":110,"6":130,"7":150,"8":170},"childrenPrices":{"1":50,"2":50,"3":70,"4":90,"5":110,"6":130,"7":150,"8":170},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":50,"adultsPrices":{"1":50,"2":50,"3":70,"4":90,"5":110,"6":130,"7":150,"8":170},"childrenPrices":{"1":50,"2":50,"3":70,"4":90,"5":110,"6":130,"7":150,"8":170},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":false,"basePrice":50,"adultsPrices":{"1":50,"2":50,"3":70,"4":90,"5":110,"6":130,"7":150,"8":170},"childrenPrices":{"1":50,"2":50,"3":70,"4":90,"5":110,"6":130,"7":150,"8":170},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0}}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":50,"adultsPrices":{"1":50,"2":50,"3":70},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":0,"2":0,"3":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":50,"adultsPrices":{"1":50,"2":50,"3":70},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":0,"2":0,"3":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":50,"adultsPrices":{"1":50,"2":50,"3":70},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":0,"2":0,"3":0}}}}],[{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":80,"adultsPrices":{"1":80,"2":80,"3":80,"4":80,"5":80},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":80,"adultsPrices":{"1":80,"2":80,"3":80,"4":80,"5":80},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0}}}},{"basePax":2,"minStays":{"1":{"hasChildRate":true,"basePrice":80,"adultsPrices":{"1":80,"2":80,"3":80,"4":80,"5":80},"childrenPrices":{"1":10,"2":20,"3":30},"infantsPrices":{"1":0,"2":0,"3":0,"4":0,"5":0}}}}]];
    return validPricings;
};